import icon from "../../assets/motion.svg";
import type { Property } from "../../types";

export const smartDetections: Property = {
  id: "smartDetections",
  title: "smartDetections.title",
  tooltip: "smartDetections.tooltip",
  icon,
};
